import type { LayerState } from '@vitals/shared';
import type { VitalDef } from './vitals.js';

/**
 * Vital selector for airborne fixed-wing aircraft overhead.
 *
 * Display: value = planes (total − helicopters), label "planes".
 * Backed by the existing 'flights' layer summary.
 */
export const planesVital: VitalDef = {
  id: 'planes',
  layerId: 'flights',

  select(s: LayerState | undefined) {
    const isDown = !s || s.status === 'down' || s.summary == null;
    if (isDown) {
      return {
        value: '—',
        label: 'planes',
        down: true,
        stale: false,
      };
    }

    const stale = s.status === 'stale';
    const { total, helicopters } = s.summary as { total: number; helicopters: number };
    const planes = total - helicopters;

    return {
      value: `${planes}`,
      label: 'planes',
      down: false,
      stale,
    };
  },
};
